import { IconClose16, TDeviceType } from '@cian/ui-kit';
import React, { useEffect, useRef } from 'react';
import { Escape } from '@cian/ui-kit/services/Escape';
import cn from 'classnames';

import * as styles from './styles.css';

export const VideoPlaybackModal: React.FC<{
  isOpen: boolean;
  deviceType: TDeviceType;
  onClose(): void;
  videoSrc: string;
}> = ({ isOpen, deviceType, onClose, videoSrc }) => {
  const isPhone = deviceType === 'phone';
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isOpen) {
      ref.current?.focus();
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'initial';
    }
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  return (
    <Escape active onEscape={onClose}>
      <div
        role="dialog"
        ref={ref}
        className={cn(styles['modal-container'], { [styles['is-phone']]: isPhone })}
        data-testid="video-playback-modal"
      >
        <button className={styles['close-button']} aria-label="Закрыть" onClick={onClose}>
          <IconClose16 color="white_100" />
        </button>
        <div className={styles['background']} onClick={onClose} aria-hidden="true" />
        <div className={styles['modal-content']}>
          <iframe
            className={styles['video-iframe']}
            src={videoSrc}
            title="Видео о возможностях Циан.Сделки"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </div>
    </Escape>
  );
};
